import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import { useGlobalStore } from '@/store/global';
    import { Country } from '@/enums/Country';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawalBadge',
  props: {
        persistentTooltip: Boolean,
        useBigIcons: Boolean,
    },
  setup(__props) {

const props = __props

    const globalStore = useGlobalStore();

    

    const tooltipPersistent = ref(false);
    // Needed so that the Button doesn't show too late
    const showButton = ref(false);

    function disableTutorial() {
        tooltipPersistent.value = false;
        globalStore.showTutorial = false;

        // Hide Button when inital tooltip is closed
        setTimeout(() => {
            showButton.value = false;
        }, 200);
    }

    onMounted(() => {
        if (globalStore.showTutorial) {
            showButton.value = props.persistentTooltip;

            setTimeout(() => {
                tooltipPersistent.value = props.persistentTooltip;
            }, 1000);
        }
    });

return { __sfc: true,globalStore, props, tooltipPersistent, showButton, disableTutorial, Country }
}

})